export class HelioSDKError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'HelioSDKError';
  }
}
